export function NoAccessCard() {
  return (
    <div
      className="text-center font-sans mt-[10%]"
      id="login-box"
    >
      <div>
        <img
          src="/dist/img/404-error.jpg"
          className="mb-2.5 h-[150px] w-[150px]"
          alt=""
        />
        <h3>
          Oops... you don't have access. <br />
          Please contact your admin to get the access.
        </h3>
      </div>
    </div>
  );
}
